import styled from 'styled-components/macro';

export const Container = styled.div`
  display: flex;
  padding: 48px 57px;
  align-items: center;
  justify-content: center;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    padding: 10px 0px;
    padding-bottom: 0px;
  }
`;

export const TableContent = styled.div`
  width: 100%;
  table {
    thead {
      th {
        min-width: 40px;
        @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
          &:first-child {
            opacity: 0;
          }
        }
        & > div {
          text-transform: uppercase;
          color: ${({ theme }) => theme.dark};
          justify-content: center;
          &:nth-child(2n) {
            font-family: ${({ theme }) => theme.primaryFontBold};
          }
        }
      }
    }
    tbody,
    tfoot {
      td {
        &:first-child {
          text-align: left;
        }
      }
    }
    th,
    td {
      text-align: center;
      font-family: ${({ theme }) => theme.primaryFontLight};
      &:nth-child(2n) {
        font-family: ${({ theme }) => theme.primaryFontBold};
      }
    }
  }
`;
export const Total = styled.span`
  text-transform: uppercase;
`;
export const LegendContainer = styled.div`
  line-height: 15px;
  margin-top: 20px;
`;
export const LegendItem = styled.div`
  display: inline-block;
  font-size: 10px;
  margin-right: 5px;
`;
export const LegendTitle = styled.span`
  font-family: ${({ theme }) => theme.primaryFontBold};
`;
export const LegendDescription = styled.span`
  font-family: ${({ theme }) => theme.primaryFontLight};
  margin-left: 3px;
`;
